export const BASE_URL = 'form-template-keys';
